"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _web3Utils = _interopRequireDefault(require("web3-utils"));

var _account = _interopRequireDefault(require("./account"));

var _ens = _interopRequireDefault(require("./contract/ens"));

var _xrt = _interopRequireDefault(require("./contract/xrt"));

var _factory = _interopRequireDefault(require("./contract/factory"));

var _lighthouse = _interopRequireDefault(require("./contract/lighthouse"));

var _messenger = _interopRequireDefault(require("./messenger/messenger"));

var _demand = _interopRequireDefault(require("./messenger/message/demand"));

var _offer = _interopRequireDefault(require("./messenger/message/offer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Robonomics = /*#__PURE__*/function () {
  function Robonomics() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Robonomics);

    this.web3 = null;
    this.account = null;
    this.ens = null;
    this.messageProvider = null;
    this.xrt = null;
    this.factory = null;
    this.lighthouse = null;
    this.messenger = null;
    this.load = [];
    this.init(config);
  }

  _createClass(Robonomics, [{
    key: "init",
    value: function init(config) {
      if (config.web3) {
        this.setWeb3(config.web3);
      } else {
        throw new Error("Bad config web3");
      }

      if (config.account) {
        this.initAccount(config.account);
      }

      this.initEns(config.ens);
      this.load.push(this.initXrt());
      this.load.push(this.initFactory());

      if (config.messageProvider) {
        this.setMessageProvider(config.messageProvider);
      }

      if (config.lighthouse) {
        this.load.push(this.initLighthouse(config.lighthouse));
      }
    }
  }, {
    key: "ready",
    value: function ready() {
      return Promise.all(this.load);
    }
  }, {
    key: "setWeb3",
    value: function setWeb3(web3) {
      this.web3 = web3;
    }
  }, {
    key: "setAccount",
    value: function setAccount(account) {
      var _this = this;

      this.account = account;

      if (this.web3.currentProvider.isMetaMask) {
        this.account.setSigner(function (msg) {
          return new Promise(function (resolve, reject) {
            _this.web3.eth.sign(msg, _this.account.address, function (error, result) {
              if (error) {
                reject(error);
                return;
              }

              resolve(result);
            });
          });
        });
      }
    }
  }, {
    key: "initAccount",
    value: function initAccount(config) {
      this.setAccount(new _account["default"](config.address || null, config.privateKey || null, config.isSignPrefix === undefined ? true : Boolean(config.isSignPrefix)));
    }
  }, {
    key: "setEns",
    value: function setEns(ens) {
      this.ens = ens;
    }
  }, {
    key: "initEns",
    value: function initEns() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.web3 === null) {
        throw new Error("Require web3");
      }

      this.setEns(new _ens["default"](this.web3, config.address || "0x314159265dD8dbb310642f98f50C066173C1259b", config.version || 5, config.suffix || "eth"));
    }
  }, {
    key: "setMessageProvider",
    value: function setMessageProvider(provider) {
      this.messageProvider = provider;
    }
  }, {
    key: "setXrt",
    value: function setXrt(xrt) {
      this.xrt = xrt;
    }
  }, {
    key: "initXrt",
    value: function () {
      var _initXrt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var xrt;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.web3 === null)) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Require web3");

              case 2:
                if (!(this.ens === null)) {
                  _context.next = 4;
                  break;
                }

                throw new Error("Require ENS");

              case 4:
                _context.t0 = _xrt["default"];
                _context.t1 = this.web3;
                _context.next = 8;
                return this.ens.addr("xrt");

              case 8:
                _context.t2 = _context.sent;
                xrt = new _context.t0(_context.t1, _context.t2);
                this.setXrt(xrt);
                return _context.abrupt("return", xrt);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initXrt() {
        return _initXrt.apply(this, arguments);
      }

      return initXrt;
    }()
  }, {
    key: "setFactory",
    value: function setFactory(factory) {
      this.factory = factory;
    }
  }, {
    key: "initFactory",
    value: function () {
      var _initFactory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var factory;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.web3 === null)) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Require web3");

              case 2:
                if (!(this.ens === null)) {
                  _context2.next = 4;
                  break;
                }

                throw new Error("Require ENS");

              case 4:
                _context2.t0 = _factory["default"];
                _context2.t1 = this.web3;
                _context2.next = 8;
                return this.ens.addr("factory");

              case 8:
                _context2.t2 = _context2.sent;
                factory = new _context2.t0(_context2.t1, _context2.t2);
                this.setFactory(factory);
                return _context2.abrupt("return", factory);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initFactory() {
        return _initFactory.apply(this, arguments);
      }

      return initFactory;
    }()
  }, {
    key: "setLighthouse",
    value: function setLighthouse(lighthouse) {
      this.lighthouse = lighthouse;
      this.initMessenger(lighthouse);
    }
  }, {
    key: "initLighthouse",
    value: function () {
      var _initLighthouse = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(name) {
        var address, ensName, lighthouse;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.web3 === null)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error("Require web3");

              case 2:
                if (!(this.ens === null)) {
                  _context3.next = 4;
                  break;
                }

                throw new Error("Require ENS");

              case 4:
                address = name;
                ensName = name;

                if (!(_web3Utils["default"].isAddress(name) === false)) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 9;
                return this.ens.addrLighthouse(name);

              case 9:
                address = _context3.sent;
                ensName = this.ens.getUrl(name, "lighthouse");

              case 11:
                lighthouse = new _lighthouse["default"](this.web3, address, ensName);
                this.setLighthouse(lighthouse);
                return _context3.abrupt("return", lighthouse);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function initLighthouse(_x) {
        return _initLighthouse.apply(this, arguments);
      }

      return initLighthouse;
    }()
  }, {
    key: "setMessenger",
    value: function setMessenger(messenger) {
      this.messenger = messenger;
    }
  }, {
    key: "createChannel",
    value: function createChannel(lighthouse) {
      if (this.messageProvider === null) {
        throw new Error("Require messageProvider");
      }

      return this.messageProvider.createChannel(lighthouse.name);
    }
  }, {
    key: "createMessenger",
    value: function createMessenger(channel) {
      return new _messenger["default"](channel, this.account);
    }
  }, {
    key: "initMessenger",
    value: function initMessenger(lighthouse) {
      var channel = this.createChannel(lighthouse);
      var messenger = this.createMessenger(channel);
      this.setMessenger(messenger);
      return messenger;
    }
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(type, data) {
        var message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.account === null)) {
                  _context4.next = 2;
                  break;
                }

                throw new Error("Require account");

              case 2:
                message = _messenger["default"].create(type, _objectSpread({
                  sender: this.account.address
                }, data));

                if (!((message instanceof _demand["default"] || message instanceof _offer["default"]) && message.nonce === 0)) {
                  _context4.next = 9;
                  break;
                }

                _context4.t0 = Number;
                _context4.next = 7;
                return this.factory.methods.nonceOf(message.sender).call();

              case 7:
                _context4.t1 = _context4.sent;
                message.nonce = (0, _context4.t0)(_context4.t1);

              case 9:
                return _context4.abrupt("return", this.messenger.send(message));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function send(_x2, _x3) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "sendDemand",
    value: function sendDemand(data) {
      var _this2 = this;

      var isWatchLiability = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return this.send(_messenger["default"].TYPE_DEMAND, data).then(function (message) {
        if (cb !== null) {
          cb(message);
        }

        if (isWatchLiability) {
          return _this2.liabilityByDemand(message);
        }

        return true;
      });
    }
  }, {
    key: "liabilityByDemand",
    value: function liabilityByDemand(message) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var watcher = _this3.onLiability(function (e, liability) {
          if (e) {
            watcher.unsubscribe();
            return reject(e);
          }

          liability.equalDemand(message.getHash()).then(function (r) {
            if (r) {
              watcher.unsubscribe();
              resolve(liability);
            }
          })["catch"](function (e) {
            watcher.unsubscribe();
            reject(e);
          });
        });
      });
    }
  }, {
    key: "onDemand",
    value: function onDemand(model, cb) {
      return this.messenger.onDemand(function (err, message) {
        if (err) {
          return;
        }

        if (model === null || message.model === model) {
          cb(message);
        }
      });
    }
  }, {
    key: "sendOffer",
    value: function sendOffer(data) {
      var _this4 = this;

      var isWatchLiability = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return this.send(_messenger["default"].TYPE_OFFER, data).then(function (message) {
        if (cb !== null) {
          cb(message);
        }

        if (isWatchLiability) {
          return _this4.liabilityByOffer(message);
        }

        return true;
      });
    }
  }, {
    key: "liabilityByOffer",
    value: function liabilityByOffer(message) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var watcher = _this5.onLiability(function (e, liability) {
          if (e) {
            watcher.unsubscribe();
            return reject(e);
          }

          liability.equalOffer(message.getHash()).then(function (r) {
            if (r) {
              watcher.unsubscribe();
              resolve(liability);
            }
          })["catch"](function (e) {
            watcher.unsubscribe();
            reject(e);
          });
        });
      });
    }
  }, {
    key: "onOffer",
    value: function onOffer(model, cb) {
      return this.messenger.onOffer(function (err, message) {
        if (err) {
          return;
        }

        if (model === null || message.model === model) {
          cb(message);
        }
      });
    }
  }, {
    key: "sendResult",
    value: function sendResult(data) {
      return this.send(_messenger["default"].TYPE_RESULT, data);
    }
  }, {
    key: "onResult",
    value: function onResult(cb) {
      return this.messenger.onResult(function (err, message) {
        if (err) {
          return;
        }

        cb(message);
      });
    }
  }, {
    key: "onLiability",
    value: function onLiability(cb) {
      var _this6 = this;

      return this.factory.onLiability(function (e, liability) {
        if (e) {
          cb(e);
          return;
        }

        liability.lighthouse().then(function (r) {
          if (r === _this6.lighthouse.address) {
            cb(null, liability);
          }
        });
      });
    }
  }, {
    key: "onFeedback",
    value: function onFeedback(cb) {
      return this.messenger.onFeedback(function (err, message) {
        if (err) {
          return;
        }

        cb(message);
      });
    }
  }, {
    key: "onPending",
    value: function onPending(cb) {
      return this.messenger.onPending(function (err, message) {
        if (err) {
          return;
        }

        cb(message);
      });
    }
  }]);

  return Robonomics;
}();

exports["default"] = Robonomics;